exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".embed-container iframe[data-v-c2ddcde6],.embed-container object[data-v-c2ddcde6]{\n  position:absolute;\n  top:0;\n  left:0;\n  width:100%;\n  height:100%\n}", ""]);

// exports
